module.exports = __webpack_public_path__ + "static/media/room-7.613bf65e.jpeg";